import { ElMessage } from 'element-plus';
import { Assertion } from '@annto/fe-utils/lib/assertion';

export function setupFeUtils() {
    Assertion.useMessenger(ElMessage);
}
